import styled from '@emotion/styled';
import { IconButton } from 'ui/components/elements/IconButton/IconButton';
import UploadFile from 'ui/images/upload-file.svg';
import { useImageUpload, ImageUploadProps } from './useImageUpload';

const Align = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Preview = styled.div`
    margin-top: 12px;
`;

const Img = styled.img<{ width?: number; height?: number }>`
    width: ${(props) => props.width || 328}px;
    height: ${(props) => props.height || 184}px;
    object-fit: cover;
    border-radius: 8px;
`;

const CircleImg = styled.img`
    width: ${(props) => props.width || 100}px;
    height: ${(props) => props.height || 100}px;
    object-fit: cover;
    border-radius: 50%;
`;

/**
 * 画像のアップロードとプレビュー表示
 */
export const ImageUpload: React.FC<ImageUploadProps> = (props) => {
    const { onInput, previewUrl, uploading } = useImageUpload(props);

    return (
        <>
            <Align>
                <label htmlFor={props.fileName}>
                    <IconButton icon={UploadFile} disabled={uploading} buttonStyle={{ pointerEvents: 'none' }}>
                        画像をアップロード
                    </IconButton>
                    <input
                        id={props.fileName}
                        hidden
                        type="file"
                        accept="image/*"
                        disabled={props.disabled}
                        onChange={onInput}
                    />
                </label>
            </Align>
            {previewUrl && (
                <Preview>
                    {props.directory === 'company_profile' || props.directory === 'agent_profile' ? (
                        <CircleImg width={props.width} height={props.height} src={previewUrl} alt="プレビュー画像" />
                    ) : (
                        <Img width={props.width} height={props.height} src={previewUrl} alt="プレビュー画像" />
                    )}
                </Preview>
            )}
        </>
    );
};
